import { Backdrop, CircularProgress } from "@mui/material";
import { styled } from '@mui/material/styles';

export const CustomBackdrop = (props) => {
    const { children, ...rest } = props;

    return <Backdrop open sx={{ position: 'absolute', backgroundColor: 'rgba(255, 255, 255, 0.5)'}}{...rest}>
        {children}
    </Backdrop>
}

const LoadingScreen = () => {
    return <CustomBackdrop>
        <LoadingScreenWrapper><CircularProgress sx={{ opacity: 0.3 }} /></LoadingScreenWrapper>
    </CustomBackdrop>
}

const LoadingScreenWrapper = styled('div')(({ theme }) => ({
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)'
}));

export default LoadingScreen;